import { ItContactValue } from '@/client/accounts';
import { FlexContainer } from '@/ui/styled-ui';
import { ProgressSpinner } from 'primereact/progressspinner';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ItContactVariableCard } from './ItContactVariableCard';

type TrainingVariablesSectionProps = {
  value: ItContactValue;
  onChange: (value: ItContactValue) => void;
  nameError?: string;
  isFilled: boolean;
  isLoading?: boolean;
  isError?: boolean;
};

export const TrainingVariablesSection: React.FC<
  TrainingVariablesSectionProps
> = ({ value, onChange, nameError, isFilled, isLoading, isError }) => {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <FlexContainer direction="column" className="mt-3">
        <ProgressSpinner />
      </FlexContainer>
    );
  }

  if (isError) {
    return (
      <FlexContainer direction="column" align="flex-start" className="mt-3">
        {t('account.trainingSettings.variables.loadError')}
      </FlexContainer>
    );
  }

  return (
    <ItContactVariableCard
      value={value}
      onChange={onChange}
      nameError={nameError}
      isFilled={isFilled}
    />
  );
};
